import Vue from "vue";
import { BootstrapVue, BIconBoxArrowInRight } from "bootstrap-vue";
import vSelect from "vue-select";
import Vuelidate from "vuelidate";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import VueScrollTo from "vue-scrollto";
import VueCurrencyInput from "vue-currency-input";
import VueI18n from 'vue-i18n';
import ptMessages from './language/pt.js'
import esMessages from './language/es.js'
import enMessages from './language/en.js'
import frMessages from './language/fr.js'
import geMessages from './language/ge.js'
import hoMessages from './language/ho.js'
import configLanguage from './language/config.js'
import { setUnauthorizedCallback } from "@/common/api.js";
import 'primevue/resources/themes/saga-blue/theme.css'; // Escolha um tema
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import PrimeVue from 'primevue/config';

import "@/lib/css";

import App from "./App.vue";
import router from "@/router";
import store from "@/store";

import IdleVue from "idle-vue";

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.use(PrimeVue);

const i18n = new VueI18n({
  locale: configLanguage(), // Define o idioma padrão aqui
  messages: {
    pt: ptMessages,
    es: esMessages,
    en: enMessages,
    fr: frMessages,
    ge: geMessages,
    ho: hoMessages,
  },
});

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -90,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(VueCurrencyInput, { globalOptions: { currency: "BRL" } });

Vue.component("BIconBoxArrowInRight", BIconBoxArrowInRight);
Vue.component("v-select", vSelect);

Vue.config.productionTip = false;

Vue.filter("formatDate", function(value, format) {
  if (value && moment(String(value)).isValid()) {
    return moment(String(value)).format(format);
  }

  return value;
});

Vue.filter("numFormat", numFormat(numeral));
Vue.filter("brNumFormat", function(value, format) {
  return numeral(parseFloat(value))
    .format(format)
    .toString()
    .replace(",", "_")
    .replace(".", ",")
    .replace("_", ".");
});

const eventsEmitter = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsEmitter,
  idleTime: 360000
  // idleTime: 5000
});

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  onIdle() {
    this.$store.dispatch("os/reset");
    this.$store.commit("os/setFilters", { filters: {} });
    this.$store.commit("os/setCurrentPage", { page: 1 });
    this.$store.dispatch("os/fetchFromApi", {});
  },
  computed: {
    filial() {
      const filial = this.$store.getters["filial/filial"];

      if (filial) {
        return filial;
      }

      return null;
    },
    logo() {
      return this.$store.state.logo;
    }
  },
  mounted() {
    setUnauthorizedCallback(this.logout);
  },
  methods: {
    confirmIdentity({onConfirmIdentity, onCancel}, osExterna = false ) {
      let mecanicoOs = JSON.parse(localStorage.filial);
      if (mecanicoOs.atendeOs == 'S' || mecanicoOs.fornecExt == 'S' || osExterna) {
        onConfirmIdentity(mecanicoOs.tecnicoId)
      } else {
        this.$bvModal.show('modal-tecnicos')
        this.$eventHub.$on('select-tecnico', tecnicoId => {
          if (onConfirmIdentity) {
            onConfirmIdentity(tecnicoId)
          }
          this.$eventHub.$off('select-tecnico')
          this.$bvModal.hide('modal-tecnicos')
        })
        this.$eventHub.$on('modal-tecnicos-cancel', () => {
          this.selectedTecnico = null
          if (onCancel) {
            onCancel()
          }
          this.$eventHub.$off('select-tecnico')
        })
      }
    },
    exibirModalAvaliacao(response){
      this.$bvModal.show('modal-avaliacao')

      // response.data.pesquisa_nps.forEach(user => {
      //   if (user.nr_nota == null) {
      //     console.log('Deveria exibir')
      //     this.$bvModal.show('modal-avaliacao')

      //     this.pesquisa = {
      //       tecnicoId: response.data.tecnicoId,
      //       nr_seq_pesquisa: user.nr_sequencial
      //     }
      //   }
      // });
    },
    logout() {
      this.$swal.fire({
        title: "Oops!",
        text: "Sua sessão expirou. Por favor, faça o login novamente.",
        icon: "error"
      });

      this.$store.dispatch("filial/logout");
    }
  }
}).$mount("#app");
